module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//bg.jpg?v=65921b07";